<script setup lang="ts">

</script>

<template>
    <patternlib-empty-state>
        <patternlib-empty-state-visual slot="visual" size="big" icon-name="products" />
        <p slot="description">{{ $t('general.dataNotLoaded') }}</p>
    </patternlib-empty-state>
    <!-- <p>{{ $t('general.dataNotLoaded') }}</p> -->
</template>

<style lang="css" scoped>
</style>